// extracted by mini-css-extract-plugin
export default {"col":"WJRS2","icon-container":"ks0Hj","update":"lkngg","thank":"xZv5r","milestone":"qSemI","icon":"qBfV2","title":"j15HI"};